import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../shared/buttons/button';
import ConfirmModal from '../shared/modals/confirm-modal';
import { useFinishStudentExamMutation } from '../../hooks/react-query/use-student-exam';

export type ActionsPropsType = {
  studentExamId: number;
  hasNextPage: boolean | undefined;
  onFetchNext: any;
};

function Actions({ studentExamId, hasNextPage, onFetchNext }: ActionsPropsType) {
  const [showFinishModal, setShowFinishModal] = useState(false);
  const navigate = useNavigate();
  const { mutateAsync: finishStudentExam } = useFinishStudentExamMutation();

  return (
    <div className='grid grid-cols-2 gap-2'>
      <div className='col-span-2 flex flex-col gap-2'>
        {hasNextPage && (
          <Button
            color='green'
            content='بارگذاری بقیه سوالات'
            size='lg'
            onClick={onFetchNext}
            className='mx-auto w-2/3'
          />
        )}
        <Button
          color='yellow'
          content='اتمام آزمون'
          size='lg'
          onClick={() => setShowFinishModal(true)}
          className='mx-auto w-2/3'
        />
      </div>
      {showFinishModal && (
        <ConfirmModal
          showModal={showFinishModal}
          onConfirm={async () => {
            await finishStudentExam(studentExamId);
            setShowFinishModal(false);
            navigate('/results');
          }}
          onCancel={() => setShowFinishModal(false)}
        >
          <div className='flex flex-col gap-2'>
            {hasNextPage && <p className='text-red-500'>هنوز کل صفحات رو بررسی نکرده‌اید.</p>}
            <p>آیا از اتمام آزمون مطمئن هستید؟</p>
          </div>
        </ConfirmModal>
      )}
    </div>
  );
}

export default Actions;
